import React, { useContext, memo, forwardRef } from 'react';
import { IInput } from './interface';
import Text from '../Text';
import { Row } from 'components/Layout/Grid';
import { Container } from './styles';
import cleanBtn from 'img/icon-clean-search.svg';
import { validators } from '../Form/validators';
import { FailContext } from '../Form';
import { generateRandomId } from 'utils/GenerateRandomId';
import { Tooltip } from 'react-tooltip';
import { Visibility } from 'components/Visibility';

/**
 * @param icon Use require into this
 * @param type Input type
 */
const Input = forwardRef<HTMLInputElement, IInput>((propsDefault, ref) => {
  const fail = useContext(FailContext);

  const {
    className,
    icon,
    iconStyle,
    type,
    id,
    value,
    placeholder,
    spellCheck,
    disabled,
    name,
    onFocus,
    onBlur,
    minLength,
    maxLength,
    compare,
    multiple,
    autoFocus,
    onKeyDown,
    onKeyUp,
    onChange,
    required,
    checked,
    stateName,
    customValidate,
    searchOnClick,
    onClickIcon,
    tooltip,
    toolTipPlace,
    ...props
  } = propsDefault;

  const isValid = () => {
    if (validators[type]) {
      return validators[type](
        getValueForValidation(),
        name,
        minLength,
        required,
        compare,
        customValidate
      );
    }
    return true;
  };

  const propsInput = (propInput?: string) => {
    return propInput || undefined;
  };

  const handleOnClick = (value?: string) => {
    if (onClickIcon) {
      onClickIcon();
    } else if (searchOnClick && value) {
      searchOnClick(value);
    }
  };

  const getValueForValidation = (): any => {
    if (type === 'file') {
      const inputElement = document.getElementById(id || '') as HTMLInputElement | null;
      return inputElement?.files?.[0] || null;
    }
    return value;
  };

  const tooltipId = generateRandomId("ReactTooltip");
  
  return (
    <>
      <Container>
        <input
          ref={ref}
          id={id}
          value={type === 'file' ? undefined : value}
          disabled={disabled}
          name={propsInput(name)}
          className={className || ''}
          placeholder={propsInput(placeholder)}
          spellCheck={spellCheck}
          multiple={multiple || undefined}
          autoFocus={autoFocus}
          minLength={minLength || undefined}
          maxLength={maxLength || undefined}
          onKeyDown={onKeyDown || undefined}
          onKeyUp={onKeyUp || undefined}
          onFocus={onFocus || undefined}
          onBlur={onBlur || undefined}
          onChange={onChange || undefined}
          data-statename={propsInput(stateName)}
          data-comparename={propsInput(compare?.name)}
          data-comparevalue={propsInput(compare?.value)}
          type={type}
          required={required}
          style={isValid() && fail ? { border: '2px solid tomato' } : {}}
          autoComplete="off"
          autoCorrect="off"
          checked={checked || undefined}
          data-tooltip-content={tooltip || undefined}
          data-tooltip-id={tooltipId}
          data-tooltip-place={toolTipPlace || 'top'}
          {...props}
        />
        {isValid() && fail && (
          <Text size={12} className="animated fadeIn mt-1 color-danger position-alert">
            {isValid()}
          </Text>
        )}
        {icon && (
          <Row
            className={`absolute align-center justify-center px-2 ${icon === cleanBtn ? '' : 'paint-img'}`}
            style={iconStyle || { top: 2, right: 2, bottom: 2, borderRadius: 6 }}
          >
            <img src={icon} alt="icon-input" onClick={() => handleOnClick(value)} />
          </Row>
        )}

      </Container>
      
      <Visibility visible={!!tooltip}>
        <Tooltip id={tooltipId} variant="light" />
      </Visibility>
    </>
  );
});

export default memo(Input);
